import React from "react";
import { default as Button2 } from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { default as classnames2 } from "classnames";

const useStyles = makeStyles((theme) => ({
	button: {
		paddingLeft: 50,
		paddingRight: 50,
		paddingTop: 10,
		paddingBottom: 10,
		borderRadius: 21,
		fontSize: 20,
	},
	buttonWrapper: {
		textAlign: "center",
	},
}));

const Button = ({
	children,
	align = "left",
	onClick = () => {},
	style = {},
	className = {},
}) => {
	const classes = useStyles();
	return (
		<Container className={align === "center" ? classes.buttonWrapper : ""}>
			<Button2
				type="button"
				color="primary"
				variant="contained"
				className={classnames2(classes.button, className)}
				onClick={onClick}
				style={style}
			>
				{children}
			</Button2>
		</Container>
	);
};

export default Button;
